import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import { store } from 'src/store'

import './index.css'
// Initialize LSID early so it's available across the app and not created inside components
import { getOrCreateLSID } from 'src/utils/lsid'
import App from './App'
import * as serviceWorker from './serviceWorker'

Sentry.init({
  dsn: 'https://f8269efef4f742038f851561c0af95cb@o1397143.ingest.sentry.io/6722184',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

// ensure LSID exists (safe to call — function handles storage failures)
try {
  getOrCreateLSID()
} catch (e) {
  // don't block app startup on LSID creation
  // (if localStorage is disabled this will silently fallback)
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
